import { render, staticRenderFns } from "./ColorChart.vue?vue&type=template&id=2e6a6364"
import script from "./ColorChart.vue?vue&type=script&lang=js"
export * from "./ColorChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports